import React from "react";

import Link from "ui/Link";
import styled from "styled-components/macro";
import Typography from "ui/Typography";
import TeacherAccount from "ui/Icons/TeacherAccount";
import SproutSVG from "images/sprout.svg";
import { theme } from "ui/theme";
import { StylizedFooter } from "./StylizedFooter";

const $LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 3;
  @media screen and (${theme.BreakpointLargeTabletDown}) {
    padding-top: 2rem;
  }
`;

const $LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding-top: 0.5rem;
  svg {
    margin-right: 0.5rem;
  }
`;

const $SVGWrapper = styled.img`
  height: 4rem;
  margin-bottom: 1rem;
`;

export default function CreateAccountFooter() {
  return (
    <StylizedFooter userType="teacher">
      <$LinkContainer>
        <$SVGWrapper src={SproutSVG} role="presentation" />
        <Typography size="bodySerif">Don’t have an account?</Typography>
        <$LinkWrapper>
          <TeacherAccount role="img" size="sm" title="account profile" />
          <Link href="/create_account" analyticsName="clicked_create_account">
            Create an account
          </Link>
        </$LinkWrapper>
      </$LinkContainer>
    </StylizedFooter>
  );
}
